<template>
<div>
	<section class="content__custom">
		<div class="main-title">
			<h1 class="poll">
				revise seu envio e escolha o grupo
				{{ 'sendPoll' | translate }}
			</h1>
			<h2>{{ 'poll-subtitle' | translate | capitalize }}</h2>
		</div>
		<div class="boxes">
			<div class="box">
				<div class="box__container">
					<div class="box__body">
						<form v-if="poll.questions">
							<div class="form__group">
								<label for="title-poll">{{ 'title' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'poll-name-text' | translate | capitalize }}</p>
								<input id="title-poll" type="text" v-model="poll.name" disabled>
							</div>
							<div class="form__group">
								<label for="questionname">{{ 'question' | translate | capitalize }}</label>
								<textarea  id="questionname" type="text" v-model="poll.questions[0].content" disabled></textarea>
							</div>
							<div class="form__group">
								<label for="option1">{{ 'option-one' | translate | capitalize }}</label>
								<input id="option1" type="text"  v-model="poll.questions[0].options[0].content" disabled />
							</div>
							<div class="form__group">
								<label for="option2">{{ 'option-two' | translate | capitalize }}</label>
								<input id="option2" type="text"  v-model="poll.questions[0].options[1].content" disabled>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="box">
				<div class="box__container">
					<div class="box__body">
						<form @submit.prevent="sendPoll">
							<div class="form__group">
								<label for="groups">{{ 'Grupos' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'campaign-segment' | translate | capitalize }}</p>

								<select @change="selectGroup($event)" required>
									<option>Todos</option>
									<option v-for="(group, index) in groups" :key="group.id" :value="group.id">
										{{group.name}}
									</option>
								</select>

								<ul class="tags" v-if="notifiedGroups">
									<li class="tags__tag" v-for="filter in notifiedGroups" :key="filter.id">
										{{ filter.name }}
										<div class="tags__tag__close" @click="removeSelectedGroup(filter)">
											<i class="fas fa-times"></i>
										</div>
									</li>
								</ul>
								<span v-show="filterExists"> Esse filtro já foi inserido</span>

								<div class="form__group submit__content">
									<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
										{{ 'send' | translate | capitalize }}
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
</template>

<script>
	import alert from '../../components/alert/alert.vue';
	import modal from '../../components/modal/modal.vue';

	export default {
		name: 'pollsRevision',
		components: {
			alert,
			modal,
		},
		data() {
			return {
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				},
				pollId: 0,
				submitLoading: false,
				successMsg: false,
				filterExists: false,
				notifiedGroups: [],
			};
		},
		mounted() {
			this.$store.dispatch('getPollItem', this.$route.params.id);
			this.$store.dispatch('getGroups', this.session);
		},
		computed: {
			poll() {
				return this.$store.state.poll.poll;
			},
			groups() {
				return this.$store.state.group.groups.groups;
			},
		},
		methods: {
			sendPoll() {
				this.toggleSubmitLoading();
				const payload = {};
				payload.groups = this.notifiedGroups.map(group => Number(group.id));
				payload.pollId = this.poll.id;
				this.$store.dispatch('sendPoll', payload)
					.then(() => {
						this.validationError = '';
						this.toggleSubmitLoading();
						this.$router.push({ name: 'polls', hash: '#polls' });
					})
					.catch(() => {
						this.validationError = '';
						this.toggleSubmitLoading();
					});
			},
			selectGroup(event) {
				this.filterExists = false;

				if (this.notifiedGroups.some(group => group.id === event.target.value)) {
					this.filterExists = true;
					return;
				}

				const index = event.target.options.selectedIndex;
				this.notifiedGroups.push({
					name: event.target.options[index].textContent,
					id: event.target.value,
				});
			},
			removeSelectedGroup(obj) {
				this.notifiedGroups.splice(obj, 1);
				this.filterExists = false;
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/poll/pollsRevision.vue